/**
 * @file Discover Album Folder No Face Recognition Join - Confirm Roster Identity view.
 */

import React from 'react';
import PropTypes from 'prop-types';

import DiscoverAlbumFolderNoFrJoinConfirm from '../../components/discover/DiscoverAlbumFolderNoFrJoinConfirm';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      albumFolderId: PropTypes.string,
    }),
  }),
};

const DiscoverAlbumFolderNoFrJoinConfirmView = ({ match }) => (
  <DiscoverAlbumFolderNoFrJoinConfirm
    albumFolderId={match.params.albumFolderId}
  />
);

DiscoverAlbumFolderNoFrJoinConfirmView.propTypes = propTypes;

export default DiscoverAlbumFolderNoFrJoinConfirmView;
